import type { HasTaxiID } from "./HasTaxiID"
import type { Entity } from "./index"

export default function notInTaxi(entity: Entity): entity is Entity & { taxi_id: null | undefined } {
  return !(entity as Entity & HasTaxiID).taxi_id
}